import gql from 'graphql-tag';

export default gql`
	fragment CremationDateHistory on CremationDateHistory {
		ID
		Date
		Time
		Created
		Author
	}
`;
